export default __webpack_public_path__ + "static/media/Plan_Budgets_Illustration.01c5b106.svg";